"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = contrast;

var _polished = require("polished");

function contrast(colorA, colorB) {
  var luminanceA = (0, _polished.getLuminance)(colorA);
  var luminanceB = (0, _polished.getLuminance)(colorB);
  var pad = 0.05;
  if (luminanceA > luminanceB) return (luminanceA + pad) / (luminanceB + pad);
  return (luminanceB + pad) / (luminanceA + pad);
}